<section class="store-report">

    <!-- Filter Card -->
    <div class="card m-b-20">
        <div class="card-header">
            <i class="fa fa-bar-chart label-icon" aria-hidden="true"></i>
            <label class="p-l-5 m-b-0">Store Report</label>
        </div>
        <div class="card-body">

            <div class="row align-items-end">

                <!-- Business -->
                <div class="col-sm-2">
                    <label class="text-muted filter-label">Business</label>
                    <ng-select
                        [(ngModel)]="selectedBusinessIDs"
                        [items]="businesses"
                        bindLabel="xName"
                        bindValue="_id"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        (ngModelChange)="onBusinessChange($event)"
                    ></ng-select>
                </div>

                <!-- Store -->
                <div class="col-sm-2">
                    <label class="text-muted filter-label">Store</label>
                    <ng-select
                        [(ngModel)]="selectedStoreIDs"
                        [items]="storeOptions"
                        bindLabel="xName"
                        bindValue="_id"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        (ngModelChange)="onStoreChange($event)"
                    ></ng-select>
                </div>

                <!-- Start Date -->
                <div class="col-sm-2">
                    <label class="text-muted filter-label">Start Date <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        [class.is-invalid]="!startDate"
                        bsDatepicker
                        [(ngModel)]="startDate"
                        [bsConfig]="bsConfig"
                        placeholder="MM/DD/YYYY"
                    />
                </div>

                <!-- End Date -->
                <div class="col-sm-2">
                    <label class="text-muted filter-label">End Date <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        [class.is-invalid]="!endDate"
                        bsDatepicker
                        [(ngModel)]="endDate"
                        [bsConfig]="bsConfig"
                        placeholder="MM/DD/YYYY"
                    />
                </div>

                <!-- Buttons -->
                <div class="col-sm-2">
                    <div class="d-flex flex-column" style="gap:6px">
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="resetFilters()"
                            [disabled]="isLoading"
                        >
                            <i class="fa fa-undo" aria-hidden="true"></i>
                            Reset
                        </button>
                        <button
                            class="btn btn-info btn-sm"
                            type="button"
                            (click)="generateReport()"
                            [disabled]="isLoading || dateRangeInvalid || datesRequired"
                        >
                            <i
                                class="fa"
                                [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"
                                aria-hidden="true"
                            ></i>
                            {{ isLoading ? 'Generating...' : 'Generate Report' }}
                        </button>
                    </div>
                </div>

                <!-- Report Settings (Dealer only) -->
                <div class="col-sm-2" *ngIf="userHandlerService.userRoles.isDealer">
                    <button
                        class="btn btn-secondary btn-sm"
                        type="button"
                        (click)="openReportConfig()"
                    >
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        Report Settings
                    </button>
                </div>

            </div>

            <div *ngIf="visible">
                <store-report-config-add-edit-cmp [mode]="'auto'" [custId]="null" (onModalClose)="configModalClosed($event)"></store-report-config-add-edit-cmp>
            </div>

            <!-- Date range warning -->
            <div *ngIf="dateRangeInvalid" class="alert alert-warning m-t-10 m-b-0">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Date range cannot exceed 14 days.
            </div>

            <!-- Required dates warning -->
            <div *ngIf="datesRequired" class="alert alert-warning m-t-10 m-b-0">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Start Date and End Date are required.
            </div>

            <!-- Error -->
            <div *ngIf="errorMessage" class="alert alert-danger m-t-15 m-b-0">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMessage }}
            </div>

        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center m-t-30 m-b-30">
        <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
        <p class="text-muted m-t-10">Generating report...</p>
        <p *ngIf="loadingProgress" class="text-muted m-t-5">{{ loadingProgress }}</p>
    </div>

</section>
